// angular
// 	.module("HeroPRO")
// 	.factory("EDocUpdate", EDocUpdateFactory);

/* @ngInject */
export default function EDocUpdateFactory(HPConfig, $http) {
    return {
        update,
    };

    function update(routeParams) {
        const params = {
            FundingRequestId: routeParams.FundingRequestId,
            EDocumentRecipientId: routeParams.EDocumentRecipientId,
            RecipientStatus: routeParams.event,
            DocumentType: routeParams.DocumentType,
        };

        return $http.post(`${HPConfig.heroProApi}ESign/UpdateEDocumentRecipientStatus`, params);
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/ESign/EDocUpdateFactory.js